import moment from "moment";

const APP_DATE_LOCALE = "en-GB";

export const formatBookingDate = (value, inputFormat = "YYYY-MM-DD") => {
  if (!value) {
    return "";
  }

  const parsed = moment(value, inputFormat, true);
  const fallback = moment(value);
  const date = parsed.isValid() ? parsed : fallback;
  if (!date.isValid()) {
    return String(value);
  }

  try {
    return date.toDate().toLocaleDateString(APP_DATE_LOCALE, {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch (error) {
    return date.locale("en").format("dddd, D MMMM YYYY");
  }
};
